var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-phone-number-input',{attrs:{"translations":{
    countrySelectorLabel: _vm.$t('field.customer.country_code'),
    countrySelectorError: _vm.$t('field.customer.country'),
    phoneNumberLabel: _vm.$t('field.customer.phone_number'),
    example: _vm.$t('field.customer.example')
  },"default-country-code":_vm.defaultCountryCode,"disabled":_vm.disabled,"required":_vm.required,"clearable":""},on:{"update":_vm.onUpdate},model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}})
}
var staticRenderFns = []

export { render, staticRenderFns }